export default "__VITE_ASSET__snOm$ks5__"